<div class="row">
    <div class="col-md-12">
        <div class="card_gridTwo">
            <div class="project_title">
                <h3>{{ title }}</h3>
                <hr style="margin-top: 0px" />
            </div>

            <dx-pie-chart
                *ngIf="data?.length && !isChartShow"
                id="pie"
                type="doughnut"
                [palette]="CustomColors"
                [dataSource]="data"
                [size]="{ height: 200, width: 380 }"
            >
                <dxi-series argumentField="key" valueField="value"> </dxi-series>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend [margin]="0" horizontalAlignment="right" verticalAlignment="top"></dxo-legend>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip" format="millions"> </dxo-tooltip>
            </dx-pie-chart>

            <div *ngIf="data?.length && isChartShow" class="center_div">
                <div class="title_data_notfound">
                    <h5>{{ 'IDMS.REPORTS.NO_CHART_AVAILABLE_TO_DISPLAY_HERE' | transloco }}</h5>
                </div>
            </div>

            <div class="card_gridFour" *ngIf="Alldata" style="box-shadow: none">
                <div class="row table-wrapper">
                    <div class="col-md-12">
                        <div class="row">
                            <ng-container *ngFor="let j of Alldata">
                                <div class="col-md-4 px-0">
                                    <div class="item-content" [class.bold]="j.key == 'Total'">
                                        <span>{{ j.key }}</span>
                                    </div>
                                </div>
                                <div class="col-md-4 px-0">
                                    <div class="item-content" [class.bold]="j.key == 'Total'">
                                        <span>{{ j.value }}</span>
                                    </div>
                                </div>
                                <div class="col-md-4 px-0">
                                    <div class="item-content last">
                                        <span>{{ j.percentage | percentage }}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <!-- </ng-container>  -->
            </div>
        </div>
    </div>
</div>
